import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { whatsappLink } from "@/lib/site";
import { toast } from "sonner";
import { MessageCircle, CalendarDays } from "lucide-react";

export const AppointmentDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", date: "", message: "" });

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const msg =
      `Hello Dr. Satyam, I would like to book an appointment.\n\n` +
      `Name: ${form.name || "-"}\n` +
      `Phone: ${form.phone || "-"}\n` +
      (form.email ? `Email: ${form.email}\n` : "") +
      `Preferred Date: ${form.date || "-"}\n` +
      (form.message ? `Message: ${form.message}` : "");
    window.open(whatsappLink(msg), "_blank", "noopener,noreferrer");
    toast.success("Opening WhatsApp to confirm your appointment…", {
      description: "If nothing opens, please call us at +91 81879 71516.",
    });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px] font-body" data-testid="appointment-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-navy flex items-center gap-2">
            <CalendarDays className="h-6 w-6 text-brand-orange" /> Book an Appointment
          </DialogTitle>
          <DialogDescription className="text-ink">
            Share a few details and we'll continue on WhatsApp to confirm your slot.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <Label htmlFor="bk-name">Name</Label>
            <Input id="bk-name" required value={form.name} onChange={update("name")}
              placeholder="Your full name" data-testid="booking-name-input" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label htmlFor="bk-phone">Phone Number</Label>
              <Input id="bk-phone" required type="tel" value={form.phone} onChange={update("phone")}
                placeholder="+91" data-testid="booking-phone-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="bk-date">Preferred Date</Label>
              <Input id="bk-date" type="date" value={form.date} onChange={update("date")}
                data-testid="booking-date-input" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bk-email">Email <span className="text-muted-foreground">(optional)</span></Label>
            <Input id="bk-email" type="email" value={form.email} onChange={update("email")}
              placeholder="you@example.com" data-testid="booking-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="bk-message">Message <span className="text-muted-foreground">(optional)</span></Label>
            <Textarea id="bk-message" rows={3} value={form.message} onChange={update("message")}
              placeholder="Briefly describe your concern" data-testid="booking-message-input" />
          </div>
          <Button type="submit" data-testid="booking-submit-btn"
            className="w-full bg-brand-orange hover:bg-brand-orange-dark text-white font-semibold rounded-full h-12 text-base transition-colors">
            <MessageCircle className="h-5 w-5 mr-2" /> Send on WhatsApp
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AppointmentDialog;
